/* ─── Список бажаного ────────────────────────────────────────────
   Працює так само, як у COS: серце на фото товару додає його
   до списку, серце в хедері веде на сторінку зі списком.

   ⚠️ Список зберігається В БРАУЗЕРІ покупця (localStorage).
   Це означає: він переживає перезавантаження й закриття вкладки,
   але не переноситься на інший пристрій і не прив'язаний до
   акаунта. Так працює будь-який список бажаного без окремого
   платного застосунку.

   Ключ у пам'яті: hms_wishlist
   Формат: [{handle, title, url, price, image}]
─────────────────────────────────────────────────────────────── */
(function () {
  var КЛЮЧ = 'hms_wishlist';

  function прочитати() {
    try {
      var дані = JSON.parse(localStorage.getItem(КЛЮЧ));
      return Array.isArray(дані) ? дані : [];
    } catch (e) {
      return [];
    }
  }

  function записати(список) {
    try {
      localStorage.setItem(КЛЮЧ, JSON.stringify(список));
    } catch (e) {
      /* пам'ять переповнена або заблокована — мовчки пропускаємо */
    }
    оновитиЛічильник();
    document.dispatchEvent(new CustomEvent('wishlist:changed'));
  }

  function єВСписку(handle) {
    return прочитати().some(function (т) { return т.handle === handle; });
  }

  function перемкнути(дані) {
    var список = прочитати();
    var і = список.findIndex(function (т) { return т.handle === дані.handle; });
    if (і > -1) {
      список.splice(і, 1);
    } else {
      список.unshift(дані);
    }
    записати(список);
    return і === -1;
  }

  /* ── Лічильник ──────────────────────────────────────────────
     Біля серця в хедері числа немає — так у COS. Функція
     лишається на випадок, якщо колись захочемо його повернути:
     достатньо додати в розмітку елемент [data-wishlist-count]. */
  function оновитиЛічильник() {
    var кількість = прочитати().length;
    document.querySelectorAll('[data-wishlist-count]').forEach(function (вузол) {
      вузол.textContent = кількість;
      var бульбашка = вузол.closest('.wishlist-count-bubble');
      if (бульбашка) бульбашка.hidden = кількість === 0;
    });
  }

  /* ── Стан усіх кнопок на сторінці ──────────────────────────── */
  function оновитиКнопки() {
    document.querySelectorAll('[data-wishlist-toggle]').forEach(function (кнопка) {
      var усередині = єВСписку(кнопка.dataset.handle);
      кнопка.classList.toggle('is-active', усередині);
      кнопка.setAttribute('aria-pressed', усередині ? 'true' : 'false');
    });
  }

  /* ── Натиск на серце ───────────────────────────────────────── */
  document.addEventListener('click', function (подія) {
    var кнопка = подія.target.closest('[data-wishlist-toggle]');
    if (!кнопка) return;
    подія.preventDefault();
    подія.stopPropagation();
    перемкнути({
      handle: кнопка.dataset.handle,
      title: кнопка.dataset.title,
      url: кнопка.dataset.url,
      price: кнопка.dataset.price,
      image: кнопка.dataset.image
    });
    оновитиКнопки();
  });

  /* ── Сторінка зі списком ───────────────────────────────────── */
  function намалюватиСписок() {
    var місце = document.querySelector('[data-wishlist-list]');
    if (!місце) return;
    var порожньо = document.querySelector('[data-wishlist-empty]');
    var список = прочитати();

    if (!список.length) {
      місце.innerHTML = '';
      if (порожньо) порожньо.hidden = false;
      return;
    }
    if (порожньо) порожньо.hidden = true;

    місце.innerHTML = список.map(function (т) {
      return (
        '<li class="wishlist-item">' +
          '<a class="wishlist-item__media" href="' + т.url + '">' +
            (т.image ? '<img src="' + т.image + '" alt="" loading="lazy">' : '') +
          '</a>' +
          '<button type="button" class="wishlist-btn wishlist-btn--card is-active"' +
            ' data-wishlist-toggle data-handle="' + т.handle + '"' +
            ' aria-label="Remove from wishlist"></button>' +
          '<a class="wishlist-item__title" href="' + т.url + '">' + т.title + '</a>' +
          '<div class="wishlist-item__price">' + (т.price || '') + '</div>' +
        '</li>'
      );
    }).join('');

    /* Серця в намальованих картках порожні всередині — доповнюємо
       їх тим самим значком, що й усюди. */
    var зразок = document.querySelector('.wishlist-btn__on');
    if (зразок) {
      місце.querySelectorAll('[data-wishlist-toggle]').forEach(function (к) {
        к.innerHTML =
          '<span class="wishlist-btn__off">' + document.querySelector('.wishlist-btn__off').innerHTML + '</span>' +
          '<span class="wishlist-btn__on">' + зразок.innerHTML + '</span>';
      });
    }
  }

  document.addEventListener('wishlist:changed', намалюватиСписок);

  function старт() {
    оновитиЛічильник();
    оновитиКнопки();
    намалюватиСписок();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', старт);
  } else {
    старт();
  }

  /* Список міг змінитись в іншій вкладці — тримаємо однаково. */
  window.addEventListener('storage', function (e) {
    if (e.key === КЛЮЧ) старт();
  });
})();
